module.exports = __webpack_public_path__ + "img/17862_L.5cab7229.png";